<script>
  import calendarize from "calendarize";
  import Arrow from "./Arrow.svelte";
  import FullCalendar from "../../svelte-fullcalendar/src/FullCalendar.svelte";
  import { onMount } from "svelte";
  import axios from "axios";
  import DataSpinner from "../Spinner.svelte";
  export let year = 2019;
  export let month = 0; // Jan
  export let offset = 0; // Sun
  export let today = null; // Date
  const calendar_month = today.getMonth();
  const calendar_year = today.getFullYear();
  export let options;
  $: today_month = today && today.getMonth();
  $: today_year = today && today.getFullYear();
  $: today_day = today && today.getDate();

  let prev = calendarize(new Date(year, month - 1), offset);
  let current = calendarize(new Date(year, month), offset);
  let next = calendarize(new Date(year, month + 1), offset);

  function toPrev() {
    [current, next] = [prev, current];

    if (--month < 0) {
      month = 11;
      year--;
    }

    prev = calendarize(new Date(year, month - 1), offset);
  }

  function toNext() {
    [prev, current] = [current, next];

    if (++month > 11) {
      month = 0;
      year++;
    }

    next = calendarize(new Date(year, month + 1), offset);
  }

  function isToday(day) {
    return (
      today && today_year === year && today_month === month && today_day === day
    );
  }
  function backToCurrentDate() {
    [current] = [current];
    month = calendar_month;
    year = calendar_year;
    current = calendarize(new Date(year, month), offset);
  }
</script>

<style>
  header {
    display: flex;
    margin: 0 auto;
    margin-bottom: 2rem !important;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  h4 {
    display: block;
    text-align: center;
    text-transform: uppercase;
    font-size: 130%;
    margin: 0 1rem;
    margin-left: 3rem;
  }

  .month {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: right;
    grid-gap: 4px;
  }

  .label {
    font-weight: 300;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    background-color: #223646;
    color: white;
  }

  .date {
    height: 50px;
    font-size: 16px;
    letter-spacing: -1px;
    border: 1px solid #e6e4e4;
    padding-right: 4px;
    font-weight: 700;
    padding: 0.5rem;
  }

  .date.today {
    color: #5286fa;
    background: #c4d9fd;
    border-color: currentColor;
  }

  .date.other {
    opacity: 0.2;
  }
  .current-date-btn {
    background-color: #fff;
    color: #223646;
    padding: 4.4px 15px;
    font-size: 14px;
    border-radius: 2px;
    border: 2px solid #223646;
    margin-right: 7px;
  }

  .legends-container {
    text-align: end;
    font-size: 1.05rem;
  }

  .legends-container span {
    margin-left:12px;
  }

  .legends-container span::before{
    content:"";
    width:0px;
    font-size:0px!important;
    vertical-align: middle;
    border: 7px solid;
    border-color:inherit;
    margin-right: 2px;
  }

  @media (max-width: 1025px) {
    .legends-container {
      text-align: center;
      margin-bottom: 35px;
    }
  }

  @media (max-width:426px) {
    .legends-container {
      margin-bottom: 15px!important;
    }
  }
</style>

{#if options != null}
  <FullCalendar {options} />
{:else}
  <div class="spinner">
    <DataSpinner />
  </div>
{/if}
